import React from 'react'
import { Link } from 'react-router-dom'
import { Grid, Container, Card, CardContent, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    notfound: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        minHeight: '50vh'
    },
    link: {
        textDecoration: 'none'
    }
}));


const NotFound = () => {

    const classes = useStyles()

    return (
        <React.Fragment>
            <Container className={classes.notfound}>
                <Grid container justify='center'>
                    <Grid item xs={12} sm={8}>
                        <Card>
                            <CardContent>
                                <Typography component="p" variant="body1" align="center" color="primary">
                                    Page not found
                                </Typography>

                                <Typography component="p" variant="body1" align="center" color="primary">
                                    <Link to="/" className={classes.link}>Go to Home</Link>
                                </Typography>

                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    )
}

export default NotFound